import React, { useEffect, useState } from "react";
import "../SentimentDivergingBars/SentimentDivergingBars.css";
import { useGetSentimentsMutation } from "../../../store/api/lumi/sentiment";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { getConceptFilter } from "../../../utils/getConceptFilter";
import { debounce } from "lodash";
import Scrollbars from "react-custom-scrollbars-2";
import styles from "./Sentiment.module.css";
import SummaryForSentiment from "./SummaryForSentiment";
import { useSelector } from "react-redux";
import classes from "../SentimentBiggestChangePercentWidget/SentimentChangePercent.module.css";
import LargestSentimentMovementBar from "../SentimentBiggestChangePercentWidget/LargestSentimentMovementBar";
import { useSearchParams } from "react-router-dom";
import { Collapse, Pagination, Tooltip } from "antd";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import LoadingIndicator from "../../Summary/LoadingIndicator";

export function SentimentShare(props) {

    const flags = useSelector((state) => state.auth.flags);
    let { sentiment_share_ai } = flags;
    const [sentimentData, setSentimentData] = useState([]);
    const [sentiment, setSentiment] = useState([]);
    const [isLoading, seIstLoading] = useState(false);
    const [getSentiments] = useGetSentimentsMutation();
    const [searchParams] = useSearchParams();
    const isNewApp = searchParams.get("app") === "new";

    async function getSentimentsData() {
        seIstLoading(true);
        const conceptFilter = getConceptFilter(props);

        const { data: dataConcepts } = await getSentiments({
            id: props.id,
            concept_selector: conceptFilter,
            filter: props.filters,
        });
        props.setFilterDocCount(dataConcepts.filter_count);
        let results = [...dataConcepts.match_counts];

        // Sort by negative sentiment percentage
        results = results?.sort((a, b) => {
            const negativeA = a.sentiment_share?.negative || 0;
            const negativeB = b.sentiment_share?.negative || 0;
            return negativeB - negativeA;
        });

        setSentiment(results[0]);
        if (props && props.conceptList) {
            props.setLocalConceptOptions(results);
        }
        setSentimentData(results);
        seIstLoading(false);
    }

    useEffect(() => {
        seIstLoading(true);
        const debouncedGetVolume = debounce(getSentimentsData, 1000);

        debouncedGetVolume();

        return () => {
            debouncedGetVolume.cancel();
        };
    }, [
        props.conceptList,
        props.seletctedType,
        props.selectedPageSize,
        props.filters,
        props.conceptTypeDay,
        props.selectedLocalConcepts.length,
    ]);


    if (isLoading) {
        return (
            <Spin
                className={"spinner-by-center"}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
        );
    }
    const handleClick = (concept) => {
        if (sentiment_share_ai) {
            setSentiment(concept);
        }
    };

    let height;
    if (sentiment_share_ai) {
        height = 200;
    } else {
        height = props.widget.layout.h * 40 - 125;
    }
    const defaultHeight = props.widget.layout.h * 40 - 320;

    if (isNewApp){
        return (
            <div className={styles.widget_container}>
                <div className={styles.left_panel}>
                    <div className={classes.visualization}>
                    <div className={classes.change_type_container}>
                    <div className={classes.change_type_items}>
                        <div className={classes.change_type}>
                            <div className={classes.gridHeader}>
                                <div className={classes.headerGridContainerShareConcept}>
                                    <div className={classes.gridItemHeader}>Concept</div>
                                    <div className={classes.gridItemHeader}>Sentiment</div>
                                </div>
                            </div>
                            <Scrollbars style={{ height: height }} autoHide>
                                <div className={classes.gridContainerShareConcept}
                                     style={{ lineHeight: sentiment_share_ai ? "10px" : "inherit" }}>
                                    {sentimentData.map((concept, index) => (
                                        <div key={concept.name + index} className={classes.gridRow}>
                                            <Tooltip title={concept.name}>
                                                <div
                                                    style={{ fontSize: "14px", cursor: "pointer" }}
                                                    className={classes.gridItemConcept}
                                                    onClick={() => handleClick(concept)}
                                                    onMouseDown={(e) => e.stopPropagation()}
                                                >
                                                    {concept.name}
                                                </div>
                                            </Tooltip>

                                            <div className={classes.gridItemMovement}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <LargestSentimentMovementBar concept={concept.sentiment_share} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </div>
                    </div>
                <div className="sentiment-share-container-color">
                <div className="sentiment positive">
                    <div className="color-box"></div>
                    Positive
                </div>
                <div className="sentiment neutral">
                    <div className="color-box"></div>
                    Neutral
                </div>
                <div className="sentiment negative">
                    <div className="color-box"></div>
                    Negative
                </div>
            </div>
                </div>

                <div className={styles.right_panel}>
                <SummaryForSentiment
                            props={props}
                            additionalFilter={props.filters}
                            concept={sentiment}
                            heightSummary={props.widget.layout.h}
                            />
                </div>
            </div>
        );
    }

    return (
        <div className={classes.sentimentContainer}>
            <div className="sentiment-share-container-color">
                <div className="sentiment positive">
                    <div className="color-box"></div>
                    Positive
                </div>
                <div className="sentiment neutral">
                    <div className="color-box"></div>
                    Neutral
                </div>
                <div className="sentiment negative">
                    <div className="color-box"></div>
                    Negative
                </div>
            </div>
            <div className={classes.change_types_container}>
                <div className={classes.change_type_container}>
                    <div className={classes.change_type_items}>
                        <div className={classes.change_type}>
                            <div className={classes.gridHeader}>
                                <div className={classes.headerGridContainerShareConcept}>
                                    <div className={classes.gridItemHeader}>Concept</div>
                                    <div className={classes.gridItemHeader}>Sentiment</div>
                                </div>
                            </div>
                            <Scrollbars style={{ height: height }} autoHide>
                                <div className={classes.gridContainerShareConcept}
                                     style={{ lineHeight: sentiment_share_ai ? "10px" : "inherit" }}>
                                    {sentimentData.map((concept, index) => (
                                        <div key={concept.name + index} className={classes.gridRow}>
                                            <Tooltip title={concept.name}>
                                                <div
                                                    style={{ fontSize: "14px", cursor: "pointer" }}
                                                    className={classes.gridItemConcept}
                                                    onClick={() => handleClick(concept)}
                                                    onMouseDown={(e) => e.stopPropagation()}
                                                >
                                                    {concept.name}
                                                </div>
                                            </Tooltip>

                                            <div className={classes.gridItemMovement}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <LargestSentimentMovementBar concept={concept.sentiment_share} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </div>

            </div>

            {sentiment && sentiment_share_ai && (
                <>
                    <Scrollbars style={{ height: defaultHeight }} autoHide>
                        <div className={styles.sentimentContainer}>
                            <div className={styles.sentimentHeader}>
                                {sentiment?.sentiment_counts?.total} total mention "{sentiment?.name}"
                                <span
                                    className={styles.positive}> {sentiment?.sentiment_counts?.positive} positive</span>
                                <span
                                    className={styles.negative}> {sentiment?.sentiment_counts?.negative} negative</span>
                            </div>
                        </div>
                        <SummaryForSentiment
                            props={props}
                            additionalFilter={props.filters}
                            concept={sentiment}
                            heightSummary={props.widget.layout.h}
                            />
                    </Scrollbars>
                </>
            )}
        </div>
    );
}
